import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../../shared/providers/AuthProvider/AuthProvider';

const RequireAccountSetup = ({ children }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const shouldRedirect =
            user &&
            !user.isAccountConfigured &&
            location.pathname !== '/setup';

        if (shouldRedirect) {
            navigate('/setup', { replace: true });
        }
    }, [user, location.pathname]);

    return <>{children}</>;
};

export default RequireAccountSetup;
